<template>
    <div id="svg-wrapper" class="form-element">
        <svg xmlns="http://www.w3.org/2000/svg" :width="svgWidth" height="50" :viewBox="svgViewbox">
        <g :transform="stepGroupOffset">
        <g v-for="(step, index) in steps" :key="step.id" :transform="stepTransform(step, index)">
            <line v-if="(index + 1) < steps.length"
            :x1="stepWidth/2" y1="0" :x2="stepWidth*1.5" y2="0"
            stroke="#D8D8D8" stroke-width="2.75" :class="lineStyleForStatus(step)" />
            />

            <line v-if="(index + 1) < steps.length"
            :ref="'line' + step.id"
            :x1="stepWidth/2" y1="0" :x2="stepWidth/2" y2="0"
            stroke="#00B0D8" stroke-width="3" />
            />

            <circle :ref="'circle' + step.id" :cx="stepWidth/2" cy="0" :r="stepCircleRadius" fill="#00B0D8" :class="circleStyleForStatus(step)"/>

            <text :ref="'label' + step.id" :x="stepWidth/2" y="27" text-anchor="middle" :class="stepLabelStyleForStatus(step)">
                {{ step.label }}
            </text>
        </g>
        </g>
        </svg>
    </div>
</template>

<script>

import { gsap } from "gsap";

export default {
    name: 'steps-overview',
    props: {
        steps: Array,
        step: String,
    },
    data() {
        return {
            currentStep: "",
            svgWidth: 100,
            stepCircleRadius: 9,
            stepGroupOffset: 'translate(0,0)',
        }
    },
    computed: {
        stepId() {
            if (this.currentStep == "") {
                this.currentStep = this.step;
            }
            return this.currentStep;
        },
        svgViewbox() {
            return `0 -5 ${this.svgWidth} 40`
        },
        stepWidth() {
            if (this.steps.length <= 1) {
                return this.svgWidth;
            }

            return (this.svgWidth / (this.steps.length - 1)) - 20;
        },
    },
    mounted() {
        this.svgWidth = document.getElementById('svg-wrapper').clientWidth;
    },
    watch: {
        step() {
            if (this.step != this.stepId) {
                this.transitionAnimation();
            }

        },
        steps() {
            //depending on the length of the first title label - reposition the whole time line.
            this.$nextTick(()=>{
                if (!this.$refs.hasOwnProperty('label'+this.stepId)) {
                    this.stepGroupOffset = 'translate(0,0)';
                    return;
                }

                const midPoint = this.stepWidth/2;
                let labelWidth = this.$refs['label'+this.steps[0].id][0].getBBox().width;
                if (labelWidth < (this.stepCircleRadius * 2)) {
                    labelWidth = (this.stepCircleRadius * 2);
                }
                this.stepGroupOffset = `translate(-${midPoint - (labelWidth/2)},0)`;
            })
        }
    },
    methods: {
        hasPassedThisId(localStep) {
            let globalStepIdSeen = false;
            for (let i=0; i<this.steps.length; i++) {
                if (this.steps[i].id == localStep.id) {
                    break;
                }

                if (this.steps[i].id == this.stepId) {
                    globalStepIdSeen = true;
                }
            }
            return globalStepIdSeen;
        },
        circleStyleForStatus(localStep) {
            return this.hasPassedThisId(localStep) ? 'circle-locked' : 'circle-open';
        },
        lineStyleForStatus(localStep) {

            if (this.hasPassedThisId(localStep)) {
                return 'step-line-locked'
            }

            if (localStep.id == this.stepId) {
                return 'step-line-active';
            }

            return 'step-line-complete';

        },
        stepLabelStyleForStatus(localStep) {
            return this.hasPassedThisId(localStep) ? 'step-label-locked' : 'step-label-open';
        },
        stepTransform(step, index) {
            return `translate(${this.stepWidth * index},10)`;
        },
        transitionAnimation() {
            let tl = gsap.timeline();

            tl.to(this.$refs['line' + this.stepId],
                {
                    duration: 0.5,
                    ease: "ease.in",
                    attr: {x2: this.stepWidth * 1.5},
                    onComplete: ()=>{
                        this.currentStep = this.step;
                        this.nextStepAnimation();
                        }
                });

        },
        nextStepAnimation() {
            let tl = gsap.timeline();
            tl.addLabel("animation-start")
            tl.to(this.$refs['circle' + this.stepId],
            {
                duration: 0.2,
                ease: "Ease.in",
                attr: {r: this.stepCircleRadius + 3},
            });

            tl.to(this.$refs['circle' + this.stepId],
            {
                duration: 0.5,
                ease: "Bounce.easeOut",
                attr: {r: this.stepCircleRadius},
            });

            tl.to(this.$refs['label' + this.stepId],
            {
                duration: 0.2,
                ease: "Ease.in",
                scale: 1.25,
                transformOrigin:"50 50",
            }, "animation-start");

            tl.to(this.$refs['label' + this.stepId],
            {
                duration: 0.5,
                ease: "Bounce.easeOut",
                scale: 1,
                transformOrigin:"50 50",
            }, "animation-start");
        }
    }
}
</script>

<style>

.circle-locked {
    fill: #F1F2F2;
    stroke-width: 1;
    stroke: #D7DCEB;
}

.circle-open {
    stroke-width: 1;
    stroke-opacity: 1;
    stroke: white;
    fill: #3CAB9F
}

.step-line-locked {
    stroke: #F1F2F2;
    stroke-dasharray: 5 4;
}

.step-line-active {
    stroke: #00B0D8;
    stroke-dasharray: 5 4;

}
.step-line-complete {
    stroke: #00B0D8;
}

.step-label-locked {
    font-size: 12px;
    fill: #A7A7A7;
}

.step-label-open {
    font-size: 12px;
    fill: #333333;
}

#svg-wrapper {
    padding-top: 12px;
}

</style>
